import { render } from "./Section_Receivable.vue?vue&type=template&id=1c2874da"
import script from "./Section_Receivable.vue?vue&type=script&lang=js"
export * from "./Section_Receivable.vue?vue&type=script&lang=js"

import "./Section_Receivable.vue?vue&type=style&index=0&id=1c2874da&lang=scss"
script.render = render

export default script